import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeOtherLabelValue = createAction('CHANGE_OTHERLABEL_VALUE');

export const cleanOtherLabelAlert = createAction('CLEAN_OTHERLABEL_ALERT');

export const generateOtherLabel = (otherLabel) => (
  (dispatch) => {

    dispatch({
      type: 'BEFORE_GENERATE_OTHERLABEL'
    });

    let url = '/firefighter/otherlabel/generate';
    authFetch('POST', url, JSON.stringify(otherLabel), (json) => {
      dispatch({
        type: 'AFTER_GENERATE_OTHERLABEL',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/otherLabelActions.js